import { useState } from "react";
import { useAuth } from "../auth/AuthProvider";

export function LoginPage() {
  const { signIn, status } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    const res = await signIn(email.trim(), password);
    setBusy(false);
    if (!res.ok) setError("Anmeldung fehlgeschlagen. Bitte E-Mail und Passwort prüfen.");
  };

  return (
    <div className="login">
      <form className="login__card" onSubmit={submit} aria-label="Händler-Anmeldung">
        <h1>ShoppiPoint Händler-Terminal</h1>
        <p className="login__sub">Bitte mit deinem Händlerkonto anmelden.</p>
        <label className="field">
          <span>E-Mail</span>
          <input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="field">
          <span>Passwort</span>
          <input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error && <p className="hint hint--warn" role="alert">{error}</p>}
        <button className="btn btn--primary btn--block" type="submit" disabled={busy || status === "loading"}>
          {busy ? "Anmeldung läuft…" : "Anmelden"}
        </button>
      </form>
    </div>
  );
}
